import { useMemo } from 'react';
import { UserProfileResult } from '@mews-commander/data-access';
import { useUserDetailContext } from '../../context/userDetailContext';

export const useActiveUserDetail = (data: UserProfileResult[]) => {
    const { activeUserDetailId } = useUserDetailContext();

    return useMemo(() => {
        if (!activeUserDetailId) return undefined;

        return data?.find((user) => user.userId === activeUserDetailId);
    }, [data, activeUserDetailId]);
};
